module.exports = __webpack_public_path__ + "static/media/banner-photo768@2x.6088de74.jpg";